import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b046bcf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "emoji"
}
const _hoisted_3 = {
  key: 1,
  class: "header"
}
const _hoisted_4 = {
  key: 2,
  class: "description"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    emoji: {},
    title: {},
    description: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.emoji)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.emoji), 1))
      : _createCommentVNode("", true),
    (props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.title), 1))
      : _createCommentVNode("", true),
    (props.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.description), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})